/**
 * Download blob data as a file.
 * @param {ArrayBuffer|Blob} data - Response data (e.g. from axios with responseType: 'blob')
 * @param {string} filename - Download filename
 * @param {string} mimeType - MIME type (default: application/pdf)
 */
export const downloadBlob = (data, filename, mimeType = 'application/pdf') => {
  const url = window.URL.createObjectURL(new Blob([data], { type: mimeType }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
